export default __webpack_public_path__ + "media/images/steps/step-1-c867b46d6e8c482c8af4ce5ca03ab078.svg";